import { Component, inject } from '@angular/core';
import { KontaktService } from '../../service/kontakt/kontakt.service';
import { Observable } from 'rxjs';
import { Schaltleitung } from '../../domain/model/schaltleitung';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';

@Component({
    selector: 'tnb-kontakt-page',
    templateUrl: './kontakt-page.component.html',
    styleUrls: [
        './kontakt-page.component.scss',
    ],
    standalone: false,
})
export class KontaktPageComponent {
    private kontaktService = inject(KontaktService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);

    public schaltleitungen$: Observable<Schaltleitung[]>;

    constructor() {
        const kontaktService = this.kontaktService;
        const teilgebietSelectionService = this.teilgebietSelectionService;

        this.schaltleitungen$ = kontaktService.getKontaktdaten(
            teilgebietSelectionService.getSelectedStadtwerkeId(),
        );
    }
}
